export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14717.94e81c4c.jpg";